import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LevelService } from '../proxy/controlling/controllers/level.service';
import { ProcessService } from '../proxy/controlling/controllers/process.service';

FieldBuilder.setNamespace('Controlling');

export const LEVELPERPROCESS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('levelId', 'Entity.Level', LevelService)
    .required()
    .displayFromNested('level.name')
    .sortBy('level.name')
    .build(),
  FieldBuilder
    .foreignKey('processId', 'Entity.Process', ProcessService)
    .required()
    .displayFromNested('level.name')
    .sortBy('level.name')
    .build(),
];

export const LEVELPERPROCESS_CONFIG = {
  entityName: 'LevelPerProcess',
  localizationKey: 'Controlling::Entity.LevelPerProcess',
  fields: LEVELPERPROCESS_FIELDS,
  permission: 'ControllingActivities.LevelPerProcesses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
